module.exports = __webpack_public_path__ + "img/reception.0d2c2970.png";